import React from "react";

import { Grid } from "@material-ui/core";

import AverageDailyFootfallLevel from "./AverageDailyFootfallLevel";

const DailyFootfall: React.FC = () => {
    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <AverageDailyFootfallLevel />
            </Grid>
        </Grid>
    );
};

export default DailyFootfall;
